module.exports = __webpack_public_path__ + "img/1380811410.e6b9e725.jpg";